import {BadgeVariant} from '@/components/ui/badge'
import {useI18n} from '@/i18n'
import {TestResultAction} from '@/types/auto-assign-rule-request'

/**
 * UI filter state for test-result action lists. ADD/REMOVE/UNCHANGED share the
 * same string values as {@link TestResultAction} so `item.action === filter`
 * comparisons work when the user has picked a specific action. ALL is a UI
 * sentinel and must never match a domain action.
 */
export const AffectedFilter = {
    // eslint-disable-next-line i18next/no-literal-string -- enum constant, not a user-visible string
    ALL: 'ALL',
    // eslint-disable-next-line i18next/no-literal-string -- enum constant, not a user-visible string
    ADD: 'ADD',
    // eslint-disable-next-line i18next/no-literal-string -- enum constant, not a user-visible string
    REMOVE: 'REMOVE',
    // eslint-disable-next-line i18next/no-literal-string -- enum constant, not a user-visible string
    UNCHANGED: 'UNCHANGED',
} as const
export type AffectedFilter = typeof AffectedFilter[keyof typeof AffectedFilter]

export function useAffectedFilterLabel() {
    const i18n = useI18n()
    return (filter: AffectedFilter): string => {
        switch (filter) {
            case AffectedFilter.ALL:
                return i18n.common.all
            case AffectedFilter.ADD:
                return i18n.autoAssignRules.toAdd
            case AffectedFilter.REMOVE:
                return i18n.autoAssignRules.toRemove
            case AffectedFilter.UNCHANGED:
                return i18n.autoAssignRuleRequests.unchanged
        }
    }
}

export function useTestResultActionLabel() {
    const i18n = useI18n()
    return (action: TestResultAction): string => {
        switch (action) {
            case TestResultAction.ADD:
                return i18n.autoAssignRules.toAdd
            case TestResultAction.REMOVE:
                return i18n.autoAssignRules.toRemove
            case TestResultAction.UNCHANGED:
                return i18n.autoAssignRuleRequests.unchanged
        }
    }
}

export function testResultActionVariant(action: TestResultAction): BadgeVariant {
    switch (action) {
        case TestResultAction.ADD:
            return BadgeVariant.SUCCESS
        case TestResultAction.REMOVE:
            return BadgeVariant.DESTRUCTIVE
        case TestResultAction.UNCHANGED:
            return BadgeVariant.SECONDARY
    }
}
